module.exports = __webpack_public_path__ + "static/media/sourcesanspro-italic-webfont.8740838d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/source-sans-pro/sourcesanspro-italic-webfont.woff2
// module id = 506
// module chunks = 0